<template>
  <div>
    <search
      :title="`${$t('modal.foodsupplier')}`"
      :items="suppliers"
      idProperty="SupplierId"
      nameProperty="SupplierName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />
    <supplier-select
      modalId="foodSupplierSelectModal"
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import supplierSelect from "@/components/selects/SupplierSelects";

export default {
  data() {
    return {
      trigger: false,
      suppliers: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (
        JSON.parse(sessionStorage.getItem("isSamePage")) &&
        value.FoodSupplier
      ) {
        this.suppliers = value.FoodSupplier;
      }
    },
  },
  components: {
    search,
    supplierSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.suppliers];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.suppliers = items;
      this.set();
    },
    remove(index) {
      if (!this.suppliers[index]) return;
      this.suppliers.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.suppliers);
    },
  },
};
</script>
